import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _PropTypes from 'prop-types';
import * as React from 'react';
import { KEYS } from '../../constants/keys.js';
import { nth } from '../../utils/util.js';
import { useTabContext, getPanelId, getTabId } from '../TabsContext/TabsContext.js';
import { StyledTabList } from './StyledTabList.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["children", "onChange"];
var TabsList = /*#__PURE__*/React.forwardRef(function TabsList2(props, ref) {
  var children = props.children,
      onChange = props.onChange,
      rest = _objectWithoutProperties(props, _excluded);

  var context = useTabContext();

  if (context === null) {
    throw new TypeError("No TabContext provided");
  }

  var _React$useState = React.useState(void 0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      focusValue = _React$useState2[0],
      setFocusValue = _React$useState2[1];

  function handleKeydown(e) {
    e.stopPropagation();
    var values = React.Children.toArray(children).filter(React.isValidElement).map(function (child) {
      return child.props.value;
    });

    switch (e.key) {
      case KEYS.ARROW_LEFT:
        e.preventDefault();
        return setFocusValue(function (prev) {
          return nth(values, values.indexOf(prev) - 1);
        });

      case KEYS.ARROW_RIGHT:
        e.preventDefault();
        return setFocusValue(function (prev) {
          return nth(values, values.indexOf(prev) + 1);
        });

      case KEYS.HOME:
        e.preventDefault();
        return setFocusValue(function () {
          return values[0];
        });

      case KEYS.END:
        e.preventDefault();
        return setFocusValue(function () {
          return values[values.length - 1];
        });

      case KEYS.ENTER:
      case KEYS.SPACE:
        e.preventDefault();

        if (context && focusValue !== context.value) {
          onChange(focusValue);
        }

        break;
    }
  }

  function handleChange(value) {
    setFocusValue(value);
    onChange(value);
  }

  return /*#__PURE__*/jsx(StyledTabList, _objectSpread(_objectSpread({}, rest), {}, {
    onKeyDown: handleKeydown,
    ref: ref,
    role: "tablist",
    children: React.Children.map(children, function (child) {
      if (! /*#__PURE__*/React.isValidElement(child)) return child;
      var selected = context.value === child.props.value;
      var focused = focusValue === child.props.value;
      return /*#__PURE__*/React.cloneElement(child, {
        "aria-controls": getPanelId(context, child.props.value),
        focused: focused,
        id: getTabId(context, child.props.value),
        selected: selected,
        onChange: handleChange,
        onFocus: function onFocus() {
          if (selected && !focused) {
            handleChange(child.props.value);
          }
        }
      });
    })
  }));
});
TabsList.propTypes = {
  "children": _PropTypes.node,
  "onChange": _PropTypes.func.isRequired
};
TabsList.displayName = "TabsList";

export { TabsList };
